export class Defaults {
    static DEFAULT_FIRST_NAME = 'Anonymous'
    static DEFAULT_LAST_NAME = 'User'
    static DEFAULT_EMAIL = 'anonymous@legal25.com'
    static DEFAULT_FULL_NAME = `${Defaults.DEFAULT_FIRST_NAME} ${Defaults.DEFAULT_LAST_NAME}`
}
